import {
  createRouter,
  
  createWebHistory,
 
} from "vue-router";
import routes from "./routes";
import { auth } from "@/firebaseConfig";
import firebaseService from "@/services/firebaseService";


/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */



const Router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,
  history:  createWebHistory(),
});

Router.beforeEach((to, from, next) => {
  document.title = to.name;
  if (to.matched.some(record => record.meta.authRequired)) {
    // Load user
    auth.onAuthStateChanged(user => {
      // If user obj does not exist --> redirect to login page
      if (!user) {
        next({path: "/login"});
      } else {
        const signInDate = new Date (user.metadata.lastSignInTime);
        const currDate = new Date();
        const validDate = signInDate.getTime() + 1 * 24 * 60 * 60 * 1000 // 1 day
        if(validDate < currDate) {
          firebaseService.logout().then(() => {
            next({path: "/login", query: {notifs: 'logout'}});
          })
          
        }
         else {
          next();
         }
      }
    });
  } else {
    document.title = to.name;
    next();
  }
});



export default Router;
